module.exports = __webpack_public_path__ + "img/default_bg.2865599a.png";